<script>
import groupBy from 'lodash/groupBy'
import {
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BNavbarNav,
  BNavItem,
  BNavItemDropdown,
  BDropdownDivider,
  BButton,
} from 'bootstrap-vue-next'

import {
  propertiesComputed,
  propertiesSearchComputed,
  propertiesSearchMethods,
  authComputed,
} from '@state/helpers'

export default {
  components: {
    BNavbar,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BNavItem,
    BNavItemDropdown,
    BDropdownDivider,
    BButton,
  },
  computed: {
    ...propertiesComputed,
    ...propertiesSearchComputed,
    ...authComputed,
    eligibility() {
      return this.propertiesSearchFilters.eligibility
    },
    groupedSorts() {
      return Object.values(groupBy(this.propertiesSearchSorts, 'field')).map(
        (sortGroup) =>
          sortGroup.find(
            (sort) => sort === this.propertiesSearchSelectedSort
          ) || sortGroup.find((sort) => sort.isFieldDefault)
      )
    },
  },

  methods: {
    ...propertiesSearchMethods,
    closeDrop() {
      // Close the menu and (by passing true) return focus to the toggle button
      this.$refs.hometype.hide(true)
    },
    closeFilterDrop() {
      // Close the menu and (by passing true) return focus to the toggle button
      this.$refs.filterdrop.hide(true)
    },
    updateEligibility(filterKey, newValue) {
      this.updatePropertiesSearchFilters({
        eligibility: { [filterKey]: newValue },
      })
    },
    getTooltipContentForSort(sort, { onlyDescription = false } = {}) {
      const isSelected = sort === this.propertiesSearchSelectedSort
      return (
        (onlyDescription ? '' : isSelected ? 'ordering by ' : 'order by ') +
          sort.label.replace(/[▲▼]/g, '').trim() +
          ', ' +
          {
            'name-asc': 'from A to Z (alphabetically)',
            'name-desc': 'from Z to A (reverse alphabetically)',
            'distance-asc': 'from nearest to farthest',
            'distance-desc': 'from farthest to nearest',
          }[sort.field + '-' + sort.direction] || sort.direction + 'ending'
      )
    },
    scrollToTop() {
      this.$refs.results.scrollTop = 0
    },
    updateScrolledToTop(event) {
      this.scrolledToTop = event.target.scrollTop === 0
    },
  },
}
</script>

<template>
  <div>
    <BNavbar toggleable="lg" type="light" :class="$style.filterbar">
      <!--<b-navbar-brand href="#">NavBar</b-navbar-brand>-->

      <BNavbarToggle target="nav_collapse" />

      <BCollapse id="nav_collapse" is-nav>
        <BNavbarNav>
          <!--<b-nav-form>-->
          <BaseInput
            v-tooltip="'Search by property name, city, address or provider'"
            :value="propertiesSearchFilters.query"
            placeholder="Search"
            @update="updatePropertiesSearchFilters({ query: $event })"
          />
          <!-- <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search" v-tooltip="'Search by property name, city, address or provider'" />-->
          <!--<b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>-->
          <!--</b-nav-form>-->
          <BNavItem>Filter by:</BNavItem>
          <!--<BaseIcon name="map-marker" class="filtericon" />-->
          <BNavItemDropdown
            ref="hometype"
            v-tooltip="'Switch between licensed and unlicensed homes'"
            text="Home Type"
            right
            :menu-class="$style.filterDropdownMenu"
            style="padding-left: 10px"
          >
            <!--<template v-slot:button-content>
      <img src="~@assets/images/ohlink_icon.svg" width="20" height="20" class="d-inline-block align-middle" alt="oakland housing link icon"> Home Type
    </template>-->
            <!--changed from eligibilityFilters-->
            <div :class="$style.licensefilters">
              <BaseRadio
                :class="$style.licenseddrop"
                :value="eligibility.licensed"
                :choices="[
                  { label: 'Licensed', value: 'licensed' },
                  { label: 'Unlicensed', value: 'unlicensed' },
                ]"
                @click="closeDrop"
                @update="updateEligibility('licensed', $event)"
              />
            </div>
          </BNavItemDropdown>

          <BNavItemDropdown
            ref="filterdrop"
            v-tooltip="'Click to personalize search'"
            text="More Filters"
            right
            :menu-class="$style.filterDropdownMenu"
          >
            <div :class="$style.otherfilters">
              <BaseInputCheckbox
                :checked="eligibility.hasMi"
                label="Mental illness"
                @update="updateEligibility('hasMi', $event)"
              />
              <BaseInputCheckbox
                :checked="eligibility.hasIdd"
                label="Intellectual & developmental disability"
                @update="updateEligibility('hasIdd', $event)"
              />
            </div>
            <BDropdownDivider></BDropdownDivider>
            <div :class="$style.otherfilters">
              <label>Open to</label>
              <BaseRadio
                :value="eligibility.gender"
                :choices="[
                  { label: 'A man', value: 'male' },
                  { label: 'A woman', value: 'female' },
                ]"
                @update="updateEligibility('gender', $event)"
              />
            </div>
            <BDropdownDivider></BDropdownDivider>
            <div :class="$style.otherfilters">
              <label>Openings</label>
              <BaseInputCheckbox
                :checked="propertiesSearchFilters.onlyOpenings"
                label="Has openings"
                type="checkbox"
                @update="
                  updatePropertiesSearchFilters({ onlyOpenings: $event })
                "
              />
            </div>
            <BDropdownDivider></BDropdownDivider>
            <div :class="$style.otherfilters">
              <BaseRadio
                :value="propertiesSearchFilters.genderOfCurrentResidents"
                :choices="[
                  { label: 'Coed', value: 'Coed' },
                  { label: 'Men only', value: 'Men only' },
                  { label: 'Women only', value: 'Women only' },
                ]"
                label="Current genders in home"
                @update="
                  updatePropertiesSearchFilters({
                    genderOfCurrentResidents: $event,
                  })
                "
              />
            </div>
            <BDropdownDivider></BDropdownDivider>
            <div :class="$style.otherfilters">
              <BaseInputCheckbox
                :checked="propertiesSearchFilters.hasPrivateBedrooms"
                label="Has private bedrooms available"
                @update="
                  updatePropertiesSearchFilters({
                    hasPrivateBedrooms: $event,
                  })
                "
              />
            </div>
            <BDropdownDivider></BDropdownDivider>
            <div :class="$style.otherfilters">
              <BaseInputCheckbox
                :checked="propertiesSearchFilters.wheelchairSupportRequired"
                label="Barrier free / accessible"
                @update="
                  updatePropertiesSearchFilters({
                    wheelchairSupportRequired: $event,
                  })
                "
              />
            </div>
            <BDropdownDivider></BDropdownDivider>
            <div
              v-if="canCurrentUserRead('property', 'brokerNotes')"
              :class="$style.otherfilters"
            >
              <BaseInputCheckbox
                :checked="propertiesSearchFilters.behavioralIssues"
                label="Accepts individuals with behavioral issues"
                type="checkbox"
                @update="
                  updatePropertiesSearchFilters({ behavioralIssues: $event })
                "
              />
            </div>
            <BDropdownDivider></BDropdownDivider>
            <div :class="$style.otherfilters">
              <BButton
                variant="primary"
                size="sm"
                style="margin-right: 10px"
                @click="closeFilterDrop"
                >Done</BButton
              >
              <BButton
                variant="secondary"
                size="sm"
                @click="resetPropertiesSearchState"
                >Reset Filters</BButton
              >
            </div>
          </BNavItemDropdown>
          <div :class="$style.resetdiv">
            <BaseButton
              v-tooltip="'Reset the search'"
              :class="$style.resetSearchButton"
              aria-label="Reset the search"
              @click="resetPropertiesSearchState"
            >
              <BaseIcon :class="$style.syncButton" name="sync" />
            </BaseButton>
          </div>
        </BNavbarNav>

        <!-- Right aligned nav items -->
        <BNavbarNav class="ml-auto"> </BNavbarNav>
      </BCollapse>
    </BNavbar>
  </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.container {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #e0474c;
  box-shadow: 0 4px 2px -2px gray;
}

.searchinput {
  position: relative;
  padding-top: 17px;
  padding-left: 50px;
}

.input {
  height: 34px;
}

.filterbar {
  background-color: #fff;
}

.filterDropdownMenu {
  font-family: $content-font-family;
  font-size: 1rem;
  font-weight: $content-font-weight;
  line-height: 1.4;

  --bs-dropdown-font-size: 1rem;
}

.licenseddrop {
  padding-top: 8px;
  padding-left: 10px;
}

.resetSearchButton.resetSearchButton.resetSearchButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5em;
  height: 1.5em;
  padding: 0;
  margin-top: -4px;
  line-height: 1;
  vertical-align: middle;
  border-radius: 50%;
}

.resetdiv {
  padding-left: 10px;
  line-height: 36px;
  vertical-align: middle;
}

.syncButton {
  display: block;
  margin: 0;
}

.licensefilters {
  width: 240px;
  padding-top: 10px;
  padding-left: 10px;
}

.otherfilters {
  width: 320px;
  padding-top: 10px;
  padding-left: 10px;
}

.licensefilters,
.otherfilters {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  :global(label),
  :global(span),
  :global(div) {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
}
</style>
